import { Header as Container } from './styles'

export function TabsHeader({ children }) {
  return <Container>{children}</Container>
}
